import React, {Fragment, useContext, useEffect} from 'react';
import {Typography, List, ListItem, ListItemText, SvgIcon} from '@material-ui/core';
import AffinityInfoContext from "../../../../../context/AffinityContext";
import {makeStyles} from "@material-ui/core/styles";
import HikingIcon from "@mui/icons-material/Hiking";
import MedicalServicesIcon from "@mui/icons-material/MedicalServices";
import CallIcon from "@mui/icons-material/Call";
import {CurrencyFormat} from "../../../../utils/CurrencyFormat";

const FileDownload = require('js-file-download');

const useStyles = makeStyles((theme) => ({
    note: {
        fontFamily: 'Nunito',
        fontSize: 12,
        textAlign: "center",
        color: theme.palette.grey.A200,
        margin: "8px 0"
    },
    boxPrice: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "800px",
        height: "120px",
        margin: "8px 0px 8px -30px",
        backgroundColor: "#BB0D66"
    },
    boxPriceMobile: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        height: "120px",
        backgroundColor: "#BB0D66"
    },
    priceTitle: {
        fontFamily: 'EncodeSansRegular',
        fontSize: 18,
        color: "#fff"
    },
    priceText: {
        fontFamily: 'EncodeSansBold',
        fontSize: 32,
        color: "#fff"
    },
}));


function CotizacionSuccess(props) {
    const classes = useStyles();
    const {cotizacionResponse, isMobile} = props;
    const {coberturasInfo} = useContext(AffinityInfoContext);
    const coberturasSinCosto = [
        {numeroCobertura: "44", icon: HikingIcon},
        {numeroCobertura: "45", icon: MedicalServicesIcon},
        {numeroCobertura: "50", icon: CallIcon}
    ]

    useEffect(() => {
        cotizacionResponse['detalleCoberturas']["adicionales"].sort((a, b) => parseInt(a.numeroCobertura) - parseInt(b.numeroCobertura));
    }, []);

    return (
        <React.Fragment>
            <Fragment>
                <div style={{margin:"16px"}}>
                    <Typography variant="h5" gutterBottom style={{fontFamily: 'EncodeSansBold'}}>
                        Resumen de Cotización
                    </Typography>
                    <Typography gutterBottom style={{fontFamily: 'EncodeSansRegular'}}>
                        Detalle Coberturas:
                    </Typography>
                    <List dense>
                        {cotizacionResponse['detalleCoberturas']["adicionales"].map((item, index) => (
                            <ListItem key={index}>
                                <ListItemText
                                    primary={coberturasInfo[item.numeroCobertura].descripcion}
                                    secondary={`Suma Asegurada: $ ${CurrencyFormat(item.sumaAsegurada)}`}
                                />
                            </ListItem>
                        ))}
                    </List>
                    <Typography gutterBottom style={{fontFamily: 'EncodeSansRegular'}}>
                        Beneficios sin costo:
                    </Typography>
                    <List dense>
                        {coberturasSinCosto.map((item, index) => (
                            <ListItem key={index}>
                                <SvgIcon component={item.icon} fontSize="large"
                                         style={{marginRight: "16px", color: "#BB0D66"}}/>
                                <ListItemText
                                    primary={coberturasInfo[item.numeroCobertura].descripcion}
                                />
                            </ListItem>
                        ))}
                    </List>

                    <Typography className={classes.note}>
                        *La aseguradora indemnizará los daños hasta las sumas aseguradas contratadas
                    </Typography>

                </div>

                <div className={isMobile ? classes.boxPriceMobile : classes.boxPrice}>
                    <Typography className={classes.priceTitle}>Cuota mensual:</Typography>
                    <Typography
                        className={classes.priceText}>$ {cotizacionResponse['premioMensual']}</Typography>
                </div>
            </Fragment>
        </React.Fragment>
    );
}

export default CotizacionSuccess;
